import { ToggleButtonProps } from "react-aria-components";
import { ReactNode } from "react";

export enum MDSToggleButtonVariant {
  Default = "default",
  Pill = "pill",
}

export enum MDSToggleButtonSlotName {
  LeftIcon = "leftIcon",
  RightIcon = "rightIcon",
}

export interface IMDSToggleButtonProps extends ToggleButtonProps {
  ariaLabel: string;
  variant?: MDSToggleButtonVariant;
  children?: ReactNode;
}
